import { ReactElement } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';

export const ProvidersMobileSkeleton = (): ReactElement => {
  return (
    <div
      className="providersMobile__listItem"
      style={{ padding: '0 16px', background: 'var(--v3-black-0)' }}
    >
      <div
        className="providersMobile__listItem--providers"
        style={{
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          <Skeleton.Button style={{ width: 70, height: 18 }} />
          <Skeleton.Button style={{ minWidth: 20, width: 20, height: 20 }} />
        </div>

        <Skeleton.Button
          active
          style={{ minWidth: 24, width: 24, height: 24 }}
        />
      </div>
    </div>
  );
};
